<template>
    <div class="btn-container">
        <div class="slot-btn" @click="onShowClick">
            <slot>
                <el-button class="wl-green">{{$t('table_columns_display_btn')}}</el-button>
            </slot>
        </div>
        
        <el-dialog :visible.sync="showDialog" width="60%">
            <div slot="title" class="dialog-title">
                {{ $t('table_columns_display_btn') }}
                <el-checkbox style="margin-left: 40px;" v-model="columnsCheckAll" :indeterminate="columnsIndeterminate">{{ $t('select_all') }}</el-checkbox>
            </div>
            <div class="dialog-container">
                <!-- 每行三个 -->
                <el-row v-for="v in columnColumns" :key="`checkbox-row-${v}`">
                    <el-col :span="8" v-for="(vv, kk) in columns.filter(v => !v.hide).slice(v * 3, v * 3 + 3)" :key="kk">
                        <template v-if="vv.disabled">
                            <el-tooltip class="item" effect="dark" :content="$t('column_forbid_hidden')" placement="right">
                                <el-checkbox v-model="vv.check" :disabled="vv.disabled">
                                    <Tooltip
                                        :content="vv.desc"
                                        refName="tooltipOver"
                                        :fixedWidth="230"
                                    ></Tooltip>
                                </el-checkbox>
                            </el-tooltip>
                        </template>
                        <template v-else>
                            <el-checkbox v-model="vv.check" :disabled="vv.disabled"> 
                                <Tooltip
                                    :content="vv.desc"
                                    refName="tooltipOver"
                                    :fixedWidth="230"
                                ></Tooltip>
                            </el-checkbox>
                        </template>
                    </el-col>
                </el-row>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button class="wl-gray" :loading="localLoading" @click="onCancel">{{$t('btn_cancel')}}</el-button>
                <el-button class="wl-green" :loading="localLoading" @click="onCommit">{{$t('btn_confirm')}}</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import API from '@/api'
import { mapGetters } from 'vuex'
import Tooltip from '@/components/common/Tooltip'
export default {
    name: 'TableColumnsControl',
    components: {
        Tooltip
    },
    data() {return {
        showDialog: false,
        columns: [],
        columnsCheck: [],
        columnsCheckAll: false,
        columnsIndeterminate: false,
        localLoading: false
    }},
    props: {
        tableName: {
            type: String,
            default: ''
        },
        onColumnsLoad: {
            type: Function,
            default: (e) => {}
        },
        loading: {
            type: Boolean,
            default: false
        },
        disabledColumns: {
            type: Array,
            default: () => []
        },
        anyHidden: {
            type: Boolean,
            default: false
        }
    },
    mounted() {
        this.columns = this.tableColumns[this.tableName].map(v => {
            return {
                ...v,
                check: true,
                disabled: this.disabledColumns.includes(v.name)
            }
        })

        this.getColumnStatus()
    },
    methods: {
        getColumnStatus() {
            // 获取显示列状态
            this.localLoading = true
            API.common.queryFixColumns({
                siteId: this.getSite.siteId,
                tableKey: this.tableName
            }).then(res => {
                this.localLoading = false
                this.columns = this.columns.map(v => {
                    return {
                        ...v,
                        check: res.data == null || res.data.hiddenColumns == null ? true : !res.data.hiddenColumns.replace('[', '').replace(']', '').split(', ').includes(v.name)
                    }
                })
                
                this.onColumnsLoad && this.onColumnsLoad(this.columns.filter(v => v.check).map(v => v.name))  
            }).catch(e => {
                this.localLoading = false
                console.error(e)
            })
        },
        onShowClick() {
            if (!this.tableName) {
                this.$message.error('请配置 tableName')
                return
            }
            if (!this.tableColumns[this.tableName]) {
                this.$message.error(`${this.tableName} 表格配置不存在`)
                return
            }
            this.showDialog = true
        },
        onCommit() {
            this.localLoading = true
            API.common.saveFixColumns({
                siteId: this.getSite.siteId,
                tableKey: this.tableName,
                hiddenColumns: this.columns.filter(v => !v.check).map(v => v.name)
            }).then(res => {
                this.getColumnStatus()
                this.localLoading = false
                this.showDialog = false
            }).catch(e => {
                this.localLoading = false
                console.error(e)
                this.$message.error('error')
            })
        },
        onCancel() {
            this.showDialog = false
            this.getColumnStatus()
        }
    },
    computed: {
        ...mapGetters('common', {
            getSite: 'getSite',
            getUser: 'getUser'
        }),
        columnColumns() {
            const arr = Array(Math.ceil(this.columns.length / 3))
            let res = []
            for (let i = 0; i < arr.length; i ++) {
                res.push(1)
            }
            return Object.keys(res)
        },
        /**
         * 在这配置每一个会受到影响的表格
         */
        tableColumns() {
            return {
                'pbc': [
                    { name: 'serialNo', desc: this.$t('serialNo'), hide: false },
                    { name: 'topicName', desc: this.$t('TABLE_HEADER_topicName'), hide: false },
                    { name: 'topicDesc', desc: this.$t('PAFE_PBC_LIST_DESC'), hide: false },
                    { name: 'status', desc: this.$t('FORM_LABEL_PROGRESS_STATUS'), hide: false },
                    { name: 'entityName', desc: this.$t('TABLE_HEADER_entityList'), hide: false },
                    { name: 'createDate', desc: this.$t('create_date'), hide: false },
                    { name: 'dueDateStamp', desc: this.$t('KPMG_Due_Date'), hide: false },
                    { name: 'confirmDayStamp', desc: this.$t('Client_Confirmed_Due_Date'), hide: false },
                    { name: 'sourceType', desc: this.$t('PAGE_MATTERLOG_SOURCE_OF_INFORMATION'), hide: false },
                    { name: 'applyFlag', desc: this.$t('PAGE_MATTERLOG_APPLY_FLAG'), hide: false },
                    { name: 'fileNameList', desc: this.$t('TABLE_HEADER_fileNameList'), hide: false },
                    { name: 'clientUserName', desc: this.$t('PAGE_TABLE_HEADER_clientUserName'), hide: false },
                    { name: 'kpmgUserName', desc: this.$t('TABLE_HEADER_kpmgUserName'), hide: false },
                    { name: 'uploadedBy', desc: this.$t('TABLE_HEADER_uploadedBy'), hide: false },
                    { name: 'uploadedDateStamp', desc: this.$t('TABLE_HEADER_uploadedDate'), hide: false },
                    { name: 'upload', desc: this.$t('COMMON_UPLOAD'), hide: false },
                    { name: 'periodEndDateStamp', desc: this.$t('TABLE_HEADER_periodEndDate'), hide: false },
                    { name: 'messageNum', desc: this.$t('TABLE_HEAD_COMMENTS'), hide: false }
                ],
                // confirmation_detail_list
                'cfmt_dtl_lst': [
                    {name: 'uniqueId', desc: this.$t('confirmation.details_list.table.unique_id_nocss'), hide: false},
                    {name: 'type', desc: this.$t('confirmation.details_list.table.confirmation_type'), hide: false},
                    {name: 'confirmationEntityName', desc: this.$t('confirmation.details_list.table.entity_name'), hide: false},
                    {name: 'addrEntityName', desc: this.$t('confirmation.details_list.table.addressee_entity_name'), hide: false},
                    {name: 'balanceSheetDateStamp', desc: this.$t('confirmation.details_list.table.balance_sheet_date'), hide: false},
                    {name: 'ticketNo', desc: this.$t('confirmation.details_list.table.ticketNo'), hide: false},
                    {name: 'clientInchargeList', desc: this.$t('confirmation.details_list.table.client_responsible_person'), hide: false},
                    {name: 'kpInchargeList', desc: this.$t('confirmation.details_list.table.kpmg_responsible_person'), hide: false},
                    {name: 'status', desc: this.$t('confirmation.details_list.table.client_authorisation_status'), hide: false},
                    {name: 'currentStatusTimeStamp', desc: this.$t('confirmation.details_list.table.current_status_time'), hide: false},
                    // {name: 'courierTrackingNumber', desc: this.$t('confirmation.details_list.table.courier_no_2'), hide: false},
                    {name: 'dateDeliveredToAddressee', desc: this.$t('confirmation.details_list.table.dateDeliveredToAddressee'), hide: false},
                    {name: 'confirmationStatus', desc: this.$t('confirmation.details_list.table.confirmation_status_no_br'), hide: this.getUser.userType === '2'},
                    {name: 'daysOfPending', desc: this.$t('confirmation.details_list.table.days_of_pending_for_authorisation'), hide: false},
                    {name: 'courierNo', desc: this.$t('confirmation.details_list.table.courier_no'), hide: false},
                    {name: 'daysOfReceivedAndProcessedByAddressees', desc: this.$t('confirmation.details_list.table.number_of_days_since_received'), hide: false},
                    {name: 'comment', desc: this.$t('confirmation.details_list.table.input_comments'), hide: false},
                    {name: 'historicalComments', desc: this.$t('confirmation.details_list.table.historical_comments'), hide: false},
                ],
                'cfmt_dtl_lst_client': [
                    {name: 'uniqueId', desc: this.$t('confirmation.details_list.table.unique_id_nocss'), hide: false},
                    {name: 'type', desc: this.$t('confirmation.details_list.table.confirmation_type'), hide: false},
                    {name: 'confirmationEntityName', desc: this.$t('confirmation.details_list.table.entity_name'), hide: false},
                    {name: 'addrEntityName', desc: this.$t('confirmation.details_list.table.addressee_entity_name'), hide: false},
                    {name: 'balanceSheetDateStamp', desc: this.$t('confirmation.details_list.table.balance_sheet_date'), hide: false},
                    // {name: 'ticketNo', desc: this.$t('confirmation.details_list.table.ticketNo'), hide: false},
                    {name: 'clientInchargeList', desc: this.$t('confirmation.details_list.table.client_responsible_person'), hide: false},
                    {name: 'kpInchargeList', desc: this.$t('confirmation.details_list.table.kpmg_responsible_person'), hide: false},
                    {name: 'status', desc: this.$t('confirmation.details_list.table.client_authorisation_status'), hide: false},
                    {name: 'currentStatusTimeStamp', desc: this.$t('confirmation.details_list.table.current_status_time'), hide: false},
                    {name: 'confirmationStatus', desc: this.$t('confirmation.details_list.table.confirmation_status_no_br'), hide: this.getUser.userType === '2'},
                    {name: 'daysOfPending', desc: this.$t('confirmation.details_list.table.days_of_pending_for_authorisation'), hide: false},
                    {name: 'courierNo', desc: this.$t('confirmation.details_list.table.courier_no'), hide: false},
                    {name: 'daysOfReceivedAndProcessedByAddressees', desc: this.$t('confirmation.details_list.table.number_of_days_since_received'), hide: false},
                    {name: 'comment', desc: this.$t('confirmation.details_list.table.input_comments'), hide: false},
                    {name: 'historicalComments', desc: this.$t('confirmation.details_list.table.historical_comments'), hide: false},
                ]
            }
        },
        anyHiddenHere() {
            return this.columns.filter(v => !v.check).length > 0
        }
    },
    watch: {
        anyHiddenHere(v) {
            this.$emit('update:anyHidden', v)
        },
        loading(v) {
            this.localLoading = v
        },
        localLoading(v) {
            this.$emit('update:loading', v)
        },
        columns: {
            deep: true,
            handler() {
                if (this.columns.filter(v => v.check).length == this.columns.length) {
                    this.columnsCheckAll = true
                    this.columnsIndeterminate = false
                } else if (this.columns.filter(v => !v.check).length == this.columns.length) {
                    this.columnsCheckAll = false
                    this.columnsIndeterminate = false
                } else {
                    this.columnsIndeterminate = true
                }
            }
        },
        columnsCheckAll() {
            if (this.columnsCheckAll) {
                this.columns = this.columns.map(v => {
                    v.check = true
                    return v
                }) 
            } else {
                this.columns = this.columns.map(v => {
                    v.check = !!v.disabled
                    return v
                })
            }
        }
    }
}
</script>
<style scoped>
.btn-container {
    display: inline-block;
}
.dialog-title {
    display: flex;
    flex-direction: row;
    align-items: center;
}
::v-deep .el-checkbox {
    display: flex;
    flex-direction: row;
    align-items: center;
}
</style>